import React, { ReactNode } from 'react';
import { AiOutlineClockCircle, AiOutlineLoading } from 'react-icons/ai';
import { BiExitFullscreen, BiFullscreen, BiInfoCircle } from 'react-icons/bi';
import { MdOutlineAssignment } from 'react-icons/md';
// import { BsThreeDotsVertical } from 'react-icons/bs';

import TextSelect from 'components/layout/form/TextSelect';

import moment from 'moment';
import Tooltip from 'modules/Granel/pages/NewCadastro/PasswordRegistration/CustomToolip';
import { getComplementRefuel } from 'utils/getComplementRefuel';
import { getRangeDateRefuel } from 'utils/getRangeDateRefuel';
import StatusRefuel from 'components/Granel/StatusRefuel';
import {
  Container,
  Content,
  ContentFilters,
  ContentItem,
  ContentLabel,
  Header,
  HeaderRight,
  HeaderTitle,
  Item,
  Label,
  LoadingSpin,
  // Options,
  Status,
  Value,
  TooltipIcon,
} from './styles';
import TooltipItem from './TooltipItem';

interface IProps {
  showModal: boolean;
  setShowModal: React.Dispatch<React.SetStateAction<boolean>>;
  loading: boolean;
  data: any[];
  filterRequest: string;
  setFilterRequest: React.Dispatch<React.SetStateAction<string>>;
  filterSituation: string;
  setFilterSituation: React.Dispatch<React.SetStateAction<string>>;
}

const MinhasSolicitacoesContent = ({
  showModal,
  setShowModal,
  loading,
  data,
  filterRequest,
  setFilterRequest,
  filterSituation,
  setFilterSituation,
}: IProps): JSX.Element => {
  const statusValue = (status: string): string => {
    let value = '';
    switch (status) {
      case 'os-em-analise':
        value = 'OS em análise';
        break;
      case 'os-em-atendimento':
        value = 'OS em atendimento';
        break;
      case 'os-finalizada':
        value = 'OS finalizada';
        break;
      case 'os-cancelada':
        value = 'OS cancelada';
        break;
      case 'realizado':
        value = 'Agendado';
        break;
      case 'cancelado':
        value = 'Cancelado';
        break;
      case 'agendado':
        value = 'Agendado';
        break;
      case 'reprogramado':
        value = 'Reprogramado';
        break;
      case 'pedido-em-analise':
        value = 'Em análise';
        break;
      case 'confirmado':
        value = 'Confirmado';
        break;
      case 'em-rota':
        value = 'Em rota';
        break;
      case 'nao-atendido':
        value = 'Não atendido';
        break;
      case 'atendido':
        value = 'Atendido';
        break;
      case 'nao-identificado':
        value = 'Não identificado';
        break;
      case 'em-analise':
      default:
        value = 'Em análise';
        break;
    }

    return value;
  };

  const infoComponent = (item: any): any | null => {
    const text = getComplementRefuel(
      item?.statusCode,
      item?.noVisitCode ?? null,
      item?.noSupplyCode ?? null,
      item?.forecastDate ?? null,
      item?.deliveryDate ?? null,
      item?.reprogrammingDate ?? null,
      item?.caseNumber ?? null,
      item?.orderNumber ?? null
    );

    return text ? <TooltipItem text={text} /> : null;
  };

  return (
    <Container>
      <Header>
        <HeaderTitle>Minhas solicitações</HeaderTitle>
        <HeaderRight>
          <TextSelect
            placeholder="Tipo de solicitação"
            type="text"
            value={filterRequest}
            onChange={(event) => {
              setFilterRequest(event?.currentTarget?.value);
            }}
            LeadingIcon={<MdOutlineAssignment />}
          >
            <option value="refuel">Abastecimento</option>
            <option value="assistancie">Manutenção</option>
          </TextSelect>
          <TextSelect
            placeholder="Situação"
            type="text"
            value={filterSituation}
            onChange={(event) => {
              setFilterSituation(event?.currentTarget?.value);
            }}
            LeadingIcon={<AiOutlineClockCircle />}
          >
            <option value="all">Todos</option>
            {filterRequest === 'assistancie' && (
              <option value="os-em-analise">OS em análise</option>
            )}
            {filterRequest === 'assistancie' && (
              <option value="os-em-atendimento">OS em atendimento</option>
            )}
            {filterRequest === 'assistancie' && (
              <option value="os-finalizada">OS finalizada</option>
            )}
            {filterRequest === 'assistancie' && (
              <option value="os-cancelada">OS cancelada</option>
            )}
            {filterRequest === 'refuel' && (
              <option value="em-analise">Em análise</option>
            )}
            {filterRequest === 'refuel' && (
              <option value="realizado">Agendado</option>
            )}
            {filterRequest === 'refuel' && (
              <option value="cancelado">Cancelado</option>
            )}
            {filterRequest === 'refuel' && (
              <option value="agendado">Agendado</option>
            )}
            {filterRequest === 'refuel' && (
              <option value="reprogramado">Reprogramado</option>
            )}
            {filterRequest === 'refuel' && (
              <option value="confirmado">Confirmado</option>
            )}
            {filterRequest === 'refuel' && (
              <option value="em-rota">Em rota</option>
            )}
            {filterRequest === 'refuel' && (
              <option value="nao-atendido">Não atendido</option>
            )}
            {filterRequest === 'refuel' && (
              <option value="atendido">Atendido</option>
            )}
          </TextSelect>
          {showModal ? (
            <BiExitFullscreen onClick={() => setShowModal((prev) => !prev)} />
          ) : (
            <BiFullscreen onClick={() => setShowModal((prev) => !prev)} />
          )}
        </HeaderRight>
      </Header>
      <ContentFilters>
        <TextSelect
          placeholder="Tipo de solicitação"
          type="text"
          value={filterRequest}
          onChange={(event) => {
            setFilterRequest(event?.currentTarget?.value);
          }}
          LeadingIcon={<MdOutlineAssignment />}
        >
          <option value="refuel">Abastecimento</option>
          <option value="assistancie">Manutenção</option>
        </TextSelect>
        <TextSelect
          placeholder="Situação"
          type="text"
          value={filterSituation}
          onChange={(event) => {
            setFilterSituation(event?.currentTarget?.value);
          }}
          LeadingIcon={<AiOutlineClockCircle />}
        >
          <option value="all">Todos</option>
          {filterRequest === 'assistancie' && (
            <option value="os-em-analise">OS em análise</option>
          )}
          {filterRequest === 'assistancie' && (
            <option value="os-em-atendimento">OS em atendimento</option>
          )}
          {filterRequest === 'assistancie' && (
            <option value="os-finalizada">OS finalizada</option>
          )}
          {filterRequest === 'assistancie' && (
            <option value="os-cancelada">OS cancelada</option>
          )}
          {filterRequest === 'refuel' && (
            <option value="em-analise">Pedido em análise</option>
          )}
          {filterRequest === 'refuel' && (
            <option value="realizado">Pedido agendado</option>
          )}
          {filterRequest === 'refuel' && (
            <option value="cancelado">Pedido cancelado</option>
          )}
        </TextSelect>
      </ContentFilters>
      {loading ? (
        <LoadingSpin>
          <AiOutlineLoading />
        </LoadingSpin>
      ) : (
        <Content>
          {data?.length ? (
            data?.map((item: any) => {
              return (
                <>
                  {filterRequest === 'assistancie' ? (
                    <Item key={item?.caseNumber}>
                      <ContentItem>
                        <ContentLabel>
                          <Label>Número da OS</Label>
                          <Value>{item?.serviceOrder?.numberOs ?? '-'}</Value>
                        </ContentLabel>
                        <ContentLabel>
                          <Label>Data de atendimento da OS</Label>
                          <Value>
                            {item?.serviceOrder?.attendanceForecastDate
                              ? moment(
                                  item?.serviceOrder?.attendanceForecastDate
                                ).format('DD/MM/YYYY')
                              : '-'}
                          </Value>
                        </ContentLabel>
                        <ContentLabel>
                          <Label>Situação</Label>
                          <Value>
                            <Status status={item.status} />
                            {statusValue(item.status)}
                          </Value>
                        </ContentLabel>
                      </ContentItem>
                    </Item>
                  ) : (
                    <Item key={item?.caseNumber}>
                      <ContentItem>
                        <ContentLabel>
                          <Label>N° do Pedido</Label>
                          <Value>{item?.orderNumber ?? 'Processando'}</Value>
                        </ContentLabel>
                        <ContentLabel>
                          <Label>Previsão de Entrega</Label>
                          <Value>
                            {getRangeDateRefuel(
                              item.forecastDate,
                              item?.beginDate,
                              item?.endDate,
                              item?.suggestedDate,
                              item?.agreedDate,
                              null,
                              null,
                              null
                            )}
                          </Value>
                        </ContentLabel>
                        <ContentLabel>
                          <Label>Status</Label>
                          <Value>
                            <StatusRefuel statusCode={item?.statusCode} />
                            {infoComponent(item)}
                          </Value>
                        </ContentLabel>
                      </ContentItem>
                    </Item>
                  )}
                </>
              );
            })
          ) : (
            <Item key="not-found">
              <Label>Não foi encontrado nenhum item para exibir</Label>
            </Item>
          )}
        </Content>
      )}
    </Container>
  );
};

export default MinhasSolicitacoesContent;
